<template>
    <div class="radiogroup" :class="allowClear ? 'radiogroup--allow-clear' : ''">
        <label
            v-for="option in options"
            :key="option[prop]"
            class="radiogroup__container"
            @click="uncheckIfSelected(option[prop], $event)"
        >
            <input
                type="radio"
                :name="name"
                :checked="isChecked(option[prop])"
                class="radiogroup__input"
                :required="required"
                @change="onChange(option[prop])"
            />
            <div class="radiogroup__button" :class="getButtonClass(option)">
                {{ option[label] }}
            </div>
        </label>
    </div>
</template>

<script>
// @TODO adapt for FormField

export default {
    name: 'RadioGroup',
    emits: ['update:modelValue'],
    props: {
        //eslint-disable-next-line
        modelValue: {},
        options: {
            type: Array,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: 'name'
        },
        prop: {
            type: String,
            default: 'id'
        },
        required: {
            type: Boolean,
            default: false
        },
        getButtonClass: {
            type: Function,
            default: () => ''
        },
        allowClear: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        isChecked(prop) {
            return this.modelValue === prop;
        },
        onChange(prop) {
            this.$emit('update:modelValue', prop);
        },
        uncheckIfSelected(prop, event) {
            if (this.allowClear && this.modelValue === prop) {
                event.preventDefault();
                this.$emit('update:modelValue', null);
                this.$forceUpdate();
            }
        }
    }
};
</script>

<style lang="scss" src="./RadioGroup.scss"></style>
